import React from 'react';
import styles from './header-spacer.module.scss';

export interface HeaderSpacerProps {
  className?: string;
}

export function HeaderSpacer({ className = '' }: HeaderSpacerProps) {
  return (
    <div className={`${styles.HeaderSpacer} ${className}`}>
      {/* This component provides spacing after the header without adding safe area padding */}
    </div>
  );
}

export default HeaderSpacer;